import React, { Component, PropTypes } from 'react';
import './FriendListCell.css';

import availabilityLabelUtil from '../utils/availability-label.js';
import AvailabilityIndicator from './AvailabilityIndicator.js';
import UserAvatar from './UserAvatar.js';

class FriendListCell extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isBeingDragged: false
    };

    this.handleDragStart = this.handleDragStart.bind(this);
  }

  componentDidMount() {
    console.info('FriendListCell mounting!');
  }

  componentWillUnmount() {
    console.info('FriendListCell unmounting...');
  }

  handleDragStart(ev) {
    const { user, draggable } = this.props;

    // Return early if the cell isn't currently draggable to prevent any unwanted
    // side effects.
    if (!draggable) {
      return;
    }

    // ev.dataTransfer.effectAllowed = 'link';
    ev.dataTransfer.setData('user', JSON.stringify(user));

    // Otherwise, set the state.
    this.setState({ isBeingDragged: true });
  }

  handleDragEnd = (e) => {
    this.setState({ isBeingDragged: false });
  }

  render() {
    const { user, draggable } = this.props;
    const { isBeingDragged } = this.state;
    const { avatar, displayName, availability, currentRoom } = user;

    // Compose the tagline label for the cell. If the user is currently in a room,
    // and isn't offline, show the room they're in. Otherwise, show their status.
    let labelContents = availabilityLabelUtil(availability);
    if (currentRoom && availability !== 0) {
      labelContents = [ 'in ', <a key="roomLink" href="#">{currentRoom}</a> ];
    }

    let classNames = ['FriendListCell'];
    if (draggable) {
      classNames.push('FriendListCell--draggable');
    }

    if (isBeingDragged) {
      classNames.push('is-dragged');
    }

    return (
      <div className={classNames.join(' ')}
        draggable={draggable}
        onDragStart={this.handleDragStart}
        onDragEnd={this.handleDragEnd}>

        <UserAvatar wrapperClassName="FriendListCell__avatar-wrap" user={user} />

        <div className="FriendListCell__info-wrap">
          <p>
            <strong>{displayName}</strong>
            <AvailabilityIndicator availability={availability} />
          </p>
          <p className="FriendListCell__tagline">{labelContents}</p>
        </div>
      </div>
    );
  }
}

FriendListCell.defaultProps = {
  user: {
    avatar: 'https://placehold.it/40x40',
    displayName: 'Jane',

    // Props to-be-determined on the user.
    availability: 3,
    currentRoom: 'Lobby'
  },

  draggable: false
};

FriendListCell.propTypes = {
  draggable: PropTypes.bool
};

export default FriendListCell;



// WEBPACK FOOTER //
// ./src/components/FriendListCell.js